module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"result":"Ergebnis","add":"Neu","back":"Zurück","export":"Exportieren","syncStocks":"Lagerbestände synchronisieren"},"en":{"result":"Result","add":"Add","back":"Back","export":"Export","syncStocks":"Sync stocks"}}')
  delete Component.options._Ctor
}
